import { useCallback, useState } from 'react'
import { useDI } from '@/di/DIContext'

type ShareErrorType = 'permission_denied' | 'not_supported' | 'generic' | null

export function useShareQRCode() {
  const { shareService } = useDI()
  const [errorType, setErrorType] = useState<ShareErrorType>(null)

  const share = useCallback(
    async (url: string, text?: string) => {
      const shareText = text ?? 'Join us and start earning!'

      if (!shareService.isSupported()) {
        setErrorType('not_supported')
        setTimeout(() => setErrorType(null), 3000)
        return
      }

      try {
        await shareService.share({
          title: 'Join Us',
          text: shareText,
          url: url,
        })
      } catch (err) {
        if (err instanceof Error && err.name === 'AbortError') return

        const errorMessage = (err as Error).message || 'Generic Error'
        console.error('[Share] Failed to share', { message: errorMessage })

        if (err instanceof Error && err.name === 'NotAllowedError') {
          setErrorType('permission_denied')
        } else {
          setErrorType('generic')
        }
        setTimeout(() => setErrorType(null), 3000)
      }
    },
    [shareService],
  )

  return { share, errorType }
}
